import React, { Component } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import AddIcon from "@material-ui/icons/Add";
import { IPeerSupportActionDispatches, mapPeerSupportDispatchToProps } from "../../redux/actions/peerSupport";
import { IPeerSupportState, mapPeerSupportStateToProps } from "../../redux/reducers/peerSupport";
import { FirebaseProvider } from "../../laco-common/firebase/context";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import FormWidget from "../siteForms/FormWidget";
import { IForm } from "../../laco-common";
import ClientFirebase from "../../laco-common/firebase/web";
import NotificationsService from "../../laco-common/services/notifications";
import { IPSFacility, IPSAgent, PSRole, getPSRole } from "../../models/peer-support";
import UIModal from "../ui/UIModal";
import { capitalize } from "../../utils";
import { addressValidator, getAddress } from "../../models/googleMaps";
import { PSAdminContent } from ".";
import { FIREWIRE_TENANT } from "../../laco-common/base/models/tenant";
import { firewireApp } from "../../firewire";

export type AddEditProps = {
	mode: "Add" | "Edit";
	entity: "facility" | "member";
	data?: IPSFacility | IPSAgent;
	onSubmit: (data) => Promise<any>;
	btnTemplate?: React.ReactNode;
	btnClassName?: string;
};

type AddEditState = {
	open: boolean;
};

class AddEdit extends Component<
	IPeerSupportActionDispatches & IPeerSupportState & AddEditProps & IAuthProps,
	AddEditState
> {
	state = { open: false };

	componentDidMount() {}

	getTitle() {
		return `${this.props.mode} ${this.props.mode === "Add" ? capitalize(this.props.entity) : this.getName()}`;
	}

	getName(data = this.props.data): string {
		if (!data) return "";
		if (this.props.entity === "facility") return (data as IPSFacility).name;
		if (this.props.entity === "member") return `${(data as IPSAgent).first_name} ${(data as IPSAgent).last_name}`;
	}

	onSubmit(data, formConfig: IForm) {
		console.log("onAddEdit submit:", data, formConfig);
		let formattedData = data;
		if (data.address) {
			formattedData.address = getAddress(data.address);
		}
		if (data.homeAddress) {
			formattedData.homeAddress = getAddress(data.homeAddress);
		}
		if (data.workAddress) {
			formattedData.workAddress = getAddress(data.workAddress);
		}
		return this.props.onSubmit(formattedData).then(() => {
			this.setState({ open: false });
			const successMsg: string = `${this.getName(data)} ${this.props.mode === "Add" ? "added" : "updated"}.`;
			NotificationsService.success(successMsg);
		});
	}

	render() {
		const title: string = this.getTitle();
		const psRole: PSRole = getPSRole(this.props.authContext, ClientFirebase);

		return (
			<>
				<PSAdminContent uid={(this.props.data as any)?.uid}>
					{this.props.btnTemplate ? (
						<span onClick={() => this.setState({ open: true })}>{this.props.btnTemplate}</span>
					) : (
						<button
							className={clsx("btn btn-info text-uppercase", this.props.btnClassName)}
							type="button"
							onClick={() => this.setState({ open: true })}
						>
							{this.props.mode === "Add" && (
								<AddIcon style={{ fontSize: "1.2rem", marginRight: "0.3rem" }} />
							)}
							{title}
						</button>
					)}
				</PSAdminContent>
				{this.state.open && (
					<UIModal
						title={title}
						titleClassName="title-with-border flex-grow-1 ml-1 mr-4"
						regTitle={true}
						pageTitle={title}
						open={this.state.open}
						onClose={() => this.setState({ open: false })}
						showCloseIcon={true}
						style={{ maxWidth: "600px", minHeight: "40vh" }}
					>
						<FirebaseProvider
							value={{
								clientFirebase: firewireApp as any,
								firewireApp,
								tenant: FIREWIRE_TENANT,
								userPayload: this.props.authContext.userPayload,
							}}
						>
							<FormWidget
								formId={this.props.entity}
								btnText={this.props.mode === "Add" ? this.getTitle() : "Update"}
								className="add-edit-form"
								values={this.props.data}
								disableFields={{ uid: psRole !== "admin", role: psRole !== "admin" }}
								isNested={true}
								onFormSubmit={(formId: string, values, formConfig: IForm) =>
									this.onSubmit(values, formConfig)
								}
								customValidators={{
									address: addressValidator,
									homeAddress: addressValidator,
									workAddress: addressValidator,
								}}
								footerBtnContent={
									<button
										className="btn btn-link mr-2-5"
										onClick={(e) => {
											this.setState({ open: false });
										}}
									>
										Cancel
									</button>
								}
							/>
						</FirebaseProvider>
					</UIModal>
				)}
			</>
		);
	}
}

export default connect<IPeerSupportState, IPeerSupportActionDispatches, AddEditProps>(
	mapPeerSupportStateToProps,
	mapPeerSupportDispatchToProps
)(withAuth(AddEdit));
